import { useRef } from "react";

export function useUniqueId(prefix = "") {
  const ref = useRef(null);
  if (!ref.current) {
    ref.current = `${prefix}${Math.random().toString(36).slice(2, 8)}`;
  }
  return ref.current;
}
